module.exports = __webpack_public_path__ + "img/recommed-img5.45ac3e2f.jpg";